document.addEventListener("DOMContentLoaded", (event) => {
    TangentAI.init();
});

const TangentAI = function () {

    let bagVariantId = "";
    let response_id = null;
    let market = null;
    let locale = null;
    let bundleKit = "";
    let tagsData = {};
    let recommendationData = {};
    const makeupBagProductId = "6580266991716";

    const init = () => {
        const window_url = new URL(window.location.href);
        response_id = window_url.searchParams.get("resp_id");
        // market = document.getElementById("tangent-shop-market").value;
        // locale = document.getElementById("tangent-shop-locale").value;
        TangentAI.fetchRecommendation(response_id).then(recommendationData => TangentAI.displayRecommendation(recommendationData)).catch(e => console.log(e))
    }

    // let globalData = {};
    const fetchRecommendation = async (resp_id) => {
        try {
            let response = await fetch(
                `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${resp_id}&self_serve=true&multiple_variants=true`
            );
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            let globalData = await response.json();
            return globalData;
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    }

    const displayRecommendation = (data) => {
        bagVariantId = getBagVariantID(data)
        tagsData = TangentAI.getTagsDataForDyanmicVariables(data);
        bundleKit = getBundleKitName(data.tags)
        recommendationData = data;

        let selectedVariants = TangentAI.getSelectedVariantsObject(data.product_sections.section_individual_products, data.selected_variants);

        let recommendedProducts = TangentAI.getRecommendedProductDetails(selectedVariants, data.products)

        //show the Name of the user 
        displayUserName(data)

        //call bundle title & desc function
        displayBundleGreeting();

        //add bundle offer sticker
        displayBundleOfferSticker(data)

        //call bundle product display function
        displayBundleProducts(data)

        //add bundle cta to bundle block
        displayBundleCTABlock(data)

        //call greeting message funciton
        displayUpsellBlockGreeeting(data);

        // Render products in the UI
        displayUpsellProductBlock(recommendedProducts)

        //call add all to cart function
        displayAddAllToBagBlock(recommendedProducts)

        document.getElementById("bundle-add-to-cart-cta").addEventListener("click", function () {
            addBundleToCart(data);
        });

        //add on click handler to learn more tag
        addClickhandlerToLearnMore(data)

        //add close modal event listener
        addModalCloseEvent()

        //add tabs swtching event listener
        addTabSwitchEventListener()

        if (isMobile()) {
            addScrollEventListener()
        }

    };

    /************************* Fucntions to create UI Elements *****************************/

    //create username display element
    const displayUserName = (data) => {
        let userName = document.getElementById("user-name-tag");
        userName.innerText = `${data.form.user_name},`;
    }

    //add bundle title and description text
    const displayBundleGreeting = () => {
        let bundleGreeting = document.getElementById("bundle-greetings");
        let bundleGreetingMobile = document.getElementById("bundle-greet-mob");

        bundleGreeting.innerHTML = bundleKit == "essential8" ? `<p class='bundle-title' id='bundle-kit-name'>The Essential 8</p>
                <p class='bundle-description' id='bundle-tag-data'>With your <span style='font-weight:bold;text-transform:lowercase;'>${tagsData.skintone} skintone</span> and <span style='font-weight:bold;'>${tagsData.undertone} undertone</span>, this all-in-one set will get you the <span style='font-weight:bold;'>${tagsData.look} look</span> you're looking for, day or night.</p>` : `<p class='bundle-title' id='bundle-kit-name'>The Starter Kit</p>
                <p class='bundle-description' id='bundle-tag-data'>With your <span style='font-weight:bold;text-transform:lowercase;'>${tagsData.skintone} skintone</span> and <span style='font-weight:bold;'>${tagsData.undertone} undertone</span>, this set will get you the <span style='font-weight:bold;'>${tagsData.look} look</span> you're going for.</p>`;

        bundleGreetingMobile.innerHTML = bundleKit == "essential8" ? `<p class='bundle-description-mob' id='bundle-tag-data'>With your <span style='font-weight:bold;text-transform:lowercase;'>${tagsData.skintone} skintone</span> and <span style='font-weight:bold;'>${tagsData.undertone} undertone</span>, this all-in-one set will get you the <span style='font-weight:bold;'>${tagsData.look} look</span> you're looking for, day or night.</p>` : `<p class='bundle-description-mob' id='bundle-tag-data'>With your <span style='font-weight:bold;text-transform:lowercase;'>${tagsData.skintone} skintone</span> and <span style='font-weight:bold;'>${tagsData.undertone} undertone</span>, this set will get you the <span style='font-weight:bold;'>${tagsData.look} look</span> you're going for.</p>`;
    }

    //render bundle products
    const displayBundleProducts = (data) => {
        let bundleBlock = document.getElementById("bundle-product-grid");
        bundleBlock.innerHTML = data.description;
    }

    //create bundle CTA with conditional message and a seperator
    const displayBundleCTABlock = (data) => {
        let bundleProduct = getBundleProduct(data)
        let ctaBundle = document.getElementById("bundle-cta-block");
        ctaBundle.innerHTML = `
                    <div class='bundle-cta-seperator'></div>
                    <p class='bundle-free-message'>Save $${getDiscountPrice(bundleProduct)},<span style='color:#00263a;'> PLUS GET A </span>FREE BAG</p>
                    <button class='add-all-to-bag add-to-bag-btn' id='bundle-add-to-cart-cta'>ADD TO BAG &emsp;&nbsp; $${Number(bundleProduct.variants.edges[0].node.price)} &emsp;&nbsp; <s>$${Number(bundleProduct.variants.edges[0].node.compareAtPrice)}</s></button>
                `
    }

    //add bundle offer sticker if essential 8
    const displayBundleOfferSticker = (data) => {
        let bundleProduct = getBundleProduct(data)
        let stickerBlock = document.getElementById("bundle-offer-sticker");
        stickerBlock.innerHTML = `<div class='sticker-block'>
                    <div><img class='bag-sticker' src='https://cdn.shopify.com/s/files/1/0114/0621/3220/files/Endlessly_Refillable.svg?v=1733142718' alt='bag sticker' /></div><div><p class='discount-price-tag'>$${getDiscountPrice(bundleProduct)} OFF PLUS</p><p class='free-bag-offer'>FREE BAG</p></div></div>`
    }

    //crate greeting for upsell block
    const displayUpsellBlockGreeeting = (data) => {
        let upsellBlock = document.getElementById("upsell-block")
        let greetBlock = document.createElement("div")
        greetBlock.classList.add("greet-block")
        greetBlock.innerHTML = `
        <p class='greeting-title'>Prefer individual products?</p>
        <p class='greet-message'><span style='font-weight:bold;'>${data.form.user_name}</span>, here are a few individual products, shade matched for you, to get a <span style='font-weight:bold'>${tagsData.look} look</span></p> `
        upsellBlock.appendChild(greetBlock);
    }

    //create upsell product container
    const displayUpsellProductBlock = (recommendedProducts) => {
        let upsellBlock = document.getElementById("upsell-block")
        let productGridContianer = document.createElement("div");
        productGridContianer.classList.add("product-grid-container")
        let productContainer = document.createElement("div");
        productGridContianer.appendChild(productContainer);
        productContainer.classList.add("products-grid")

        const fragment = document.createDocumentFragment();
        recommendedProducts.forEach((product) => {
            let productBlock = displaySingleProductBlock(product, bundleKit);
            fragment.appendChild(productBlock);
        });
        productContainer.appendChild(fragment);
        upsellBlock.appendChild(productGridContianer)
    }

    //creating individual product UI
    const displaySingleProductBlock = (product) => {
        let productBlock = document.createElement("div");
        productBlock.classList.add("product-block");
        productBlock.innerHTML = `
        <div class='product-image-block'>
            <img class='product-img' src=${product.imageUrl} alt=${product.imageAlt.replace(' ', '_')} />
        </div>
        <div class='product-detail-block'>
            ${(bundleKit == "essential8" && product.productId == makeupBagProductId) ? `<p class='free-badge'>FREE</p>` : ''}
            <p class='product-title'>${product.title}</p>
            <div class='variant-block'>
                ${product.variantImage ? `<img class='variant-img' src=${product.variantImage} alt=${product.variantTitle} />` : ''}
            <p class='variant-title'>${product.variantTitle}</p>
            </div>
            <p class='bundle-product-learn-more' data-product-id=${product.productId} data-variant-id=${product.variantId}>Learn more</p>
            <div class='btn-block'>
                ${(product.isVariantAvailable)
                ? `<button class='add-to-bag-btn' id='btn_${product.variantId}' onclick='TangentAI.addVariantsToCart([${product.variantId}], "btn_${product.variantId}")'>ADD TO BAG &emsp; $${Number(product.price)}</button>`
                : `<button disabled class='add-to-bag-btn disabled-btn'>Sold out $${product.price}</button>`
            }
            </div>
        </div>`;
        return productBlock;
    }

    //add all to bag block
    const displayAddAllToBagBlock = (products) => {
        let upsellBlock = document.getElementById("upsell-block")
        let variantsData = getTotalAmountAndVariantsArray(products)
        let addAlltoCartBlock = document.createElement("div");
        addAlltoCartBlock.classList.add("add-all-to-cart-block");
        addAlltoCartBlock.innerHTML = `
                ${bundleKit == "essential8" ? `<p class='purchase-all-offer-header'>Buy all ${variantsData.totalVariants},<span class='sentece-breaker'> AND </span>GET A FREE BAG</p>` : ''
            }
                <button class='add-all-to-bag add-to-bag-btn' id="add-all-to-cart" onclick='TangentAI.addVariantsToCart([${variantsData.variants}], "add-all-to-cart")'>ADD ALL TO BAG &emsp;&emsp; $${variantsData.totalAmount}</button>
                `
        upsellBlock.appendChild(addAlltoCartBlock)
    }

    /*********************** Component Behavioral funcitons ************************/

    const addBundleToCart = (data) => {
        const bundleParentProduct = getBundleParentProduct(data);
        const bundleChildProducts = getBundleChildProducts(data);
        const bundleItemsForCart = getFormattedBundleItemsForCart(bundleParentProduct, bundleChildProducts, data.selected_variants);

        let formData = { 'items': bundleItemsForCart };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        }).then((res) => {
            // let addToCartBtn = document.getElementById("bundle-add-to-cart-cta")
            // addToCartBtn.innerText = "ADDED";
            // addToCartBtn.id = "added-to-cart";
            // addToCartBtn.setAttribute("disabled", true);
            window.dispatchEvent(new CustomEvent('THEME:CART_UPDATED'));
            postCartEvent(bundleParentProduct, "bundle")
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const getBundleParentProduct = (data) => {
        const bundleProductId = data.product_sections.section_bundle_parent_product[0];
        return data.products.find((product) => product.id == bundleProductId);
    }

    const getBundleChildProducts = (data) => {
        const childProductIds = data.product_sections.section_bundle_child_products;
        const productIdSet = new Set(childProductIds);
        return data.products.filter(product => productIdSet.has(product.id.toString()));
    }

    const getProductVariant = (product, variantId = null) => {
        if (variantId == null) {
            return product.variants.edges[0].node
        } else {
            const edge = product.variants.edges.find((edge) => extractIdFromGid(edge.node.id) == variantId);
            return edge.node;
        }
    }

    const extractIdFromGid = (gid) => {
        return gid.split('/').pop();
    }

    const getVariantPriceInNumber = (variant) => {
        return Number(variant.price.replace(/[^0-9.-]+/g, ""));
    }

    const getFormattedBundleItemsForCart = (bundleParentProduct, bundleChildProducts, selectedVariants) => {
        const bundleVariant = getProductVariant(bundleParentProduct);
        const totalChildProductsPrice = bundleChildProducts.reduce(
            (sum, childProduct) => {
                const variantId = selectedVariants[childProduct.id][0];
                const variant = getProductVariant(childProduct, variantId);
                return sum + getVariantPriceInNumber(variant);
            }, 0
        );
        const discount = ((totalChildProductsPrice - bundleVariant.price) / totalChildProductsPrice) * 100;

        return bundleChildProducts.map(
            (childProduct) => {
                const variantId = selectedVariants[childProduct.id][0];
                const variant = getProductVariant(childProduct, variantId);

                return {
                    "id": extractIdFromGid(variant.id),
                    "quantity": 1,
                    "properties": {
                        "_setId": extractIdFromGid(bundleVariant.id),
                        "_timestamp": Date.now(),
                        "_priceTotal": getVariantPriceInNumber(bundleVariant),
                        "_discount": discount,
                        "_type": "Tangent-quiz",
                        "_quiz-bag": bagVariantId,
                        "_kit": bundleKit
                    }
                }
            }
        );
    }

    //get total amount and variant ID array
    const getTotalAmountAndVariantsArray = (products) => {
        let variantDetails = {
            totalAmount: 0,
            variants: [],
            totalVariants: 0
        };

        for (let product of products) {
            if (product.isVariantAvailable) {
                // Add the variant ID
                variantDetails.variants.push(product.variantId);

                // Update totalAmount and totalVariants based on the global bundleKit logic
                if (bundleKit === "starterKit") {
                    variantDetails.totalAmount += Number(product.price);
                    variantDetails.totalVariants++;
                } else if (bundleKit === "essential8" && product.productId != makeupBagProductId) {
                    variantDetails.totalAmount += Number(product.price);
                    variantDetails.totalVariants++;
                }
            }
        }
        return variantDetails;
    }

    //add variant/product to cart
    const addVariantsToCart = (variant_ids, buttonId) => {
        let formData = {
            'items': variant_ids.map((variant_id) => ({ "id": variant_id, "quantity": 1, "properties": { "_type": "Tangent-quiz", "_quiz-bag": bagVariantId, "_kit": bundleKit } }))
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        }).then((res) => {
            // let addToCartBtn = document.getElementById(buttonId)
            // addToCartBtn.innerText = "ADDED";
            // addToCartBtn.id = "added-to-cart";
            // addToCartBtn.setAttribute("disabled", true);
            window.dispatchEvent(new CustomEvent('THEME:CART_UPDATED'));
            postCartEvent(variant_ids);
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    //get skintone, undertone, makeup-look data from tags list
    const getTagsDataForDyanmicVariables = (data) => {
        let tagsData = {
            undertone: "",
            skintone: "",
            look: ""
        }
        for (let tag of data.tags) {
            if (tag.includes("skintone_shade")) {
                let extractedPart = tag.replace("skintone_shade_", "");
                tagsData.skintone = extractedPart.split('_').map((word, id) => { if (id == 0) { return word.charAt(0).toUpperCase() + word.slice(1) } else { return word } }).join(' ');
            }
            if (tag.includes("undertone_final")) {
                tagsData.undertone = tag.replace("undertone_final_", "");
            }
            if (tag.includes("makeup_style")) {
                tagsData.look = tag.replace("makeup_style_", "")
            }
        }
        return tagsData;
    }

    //get bundle kit name
    const getBundleKitName = (tags) => {
        for (let tag of tags) {
            if (tag == "essential_8") {
                return "essential8"
            } if (tag == "starter_kit") {
                return "starterKit"
            }
        }
    }

    //get the filtered variants from the section
    const getSelectedVariantsObject = (individualProducts, selectedVaraints) => {
        const filteredObject = {};

        // Iterate through the array of individual product IDs
        individualProducts.forEach(productId => {
            // Check if the product ID exists in the second object
            if (selectedVaraints.hasOwnProperty(productId)) {
                // Add the product ID and its variants to the filtered object
                filteredObject[productId] = selectedVaraints[productId];
            }
        });

        return filteredObject;
    }

    //get bundled product data
    const getBundleProduct = (data) => {
        return data.products.filter((product) => product.id == data.product_sections.section_bundle_parent_product[0])[0];
    }

    //get all the recommended products' details for UI
    const getRecommendedProductDetails = (selectedVariants, productList) => {
        let resultedProducts = []
        // Map through selected variants and match them with products
        for (let productId in selectedVariants) {
            if (selectedVariants[productId].length > 0) {

                let matchingProduct = filterList(productList, productId) //get matching product

                if (matchingProduct) {
                    for (let variantId of selectedVariants[productId]) {

                        let matchingVariant = filterList(matchingProduct.variants.edges, variantId) //get matching variant

                        if (matchingVariant) {
                            let productDetails = {
                                title: matchingProduct.title,
                                handle: matchingProduct.handle,
                                productId: matchingProduct.id,
                                variantId: matchingVariant.node.id.split("/").pop(),
                                variantTitle: matchingVariant.node.title,
                                variantImage: getImageSlug("https://www.trestique.com/cdn/shop/files", matchingVariant.node.title, "png"),
                                price: matchingVariant.node.price,
                                isVariantAvailable: TangentAI.isVariantAvalaible(matchingProduct, matchingVariant.node),
                                imageUrl: matchingVariant.node.image.url,
                                imageAlt: "Product image"
                            };
                            resultedProducts.push(productDetails);
                        }
                    }
                }
            }
        }
        return resultedProducts;
    }

    //get the single item from an array with a matching id
    const filterList = (lists, matchingId) => {
        return lists.find((list) => {
            const id = list.id || list.node?.id.split("/").pop();
            return id == matchingId
        })
    }

    //get image slug
    const getImageSlug = (slugOrigin, slugName, fileType) => {
        return `${slugOrigin}/${slugName.toLowerCase().replaceAll(' ', '-')}.${fileType}`
    }

    //check variant availability
    const isVariantAvalaible = (product, variant) => {
        if (product.status == "ARCHIVED") {
            return false;
        } else {
            return (variant.inventoryQuantity > 0 || variant.inventoryPolicy === "CONTINUE");
        }
    }

    //get variant Image URL
    const getVariantImageURL = (product, variant) => {
        let variantImage = product.images.find(
            (image) => image.id === variant.image_id
        );
        return variantImage.src;
    }

    //get the discount price from compared price and actual price
    const getDiscountPrice = (bundleProduct) => {
        return (Number(bundleProduct.variants.edges[0].node.compareAtPrice) - Number(bundleProduct.variants.edges[0].node.price))
    }

    //add on click handle to all learn more 
    const addClickhandlerToLearnMore = (data) => {
        let learnMoreElements = document.getElementsByClassName("bundle-product-learn-more");
        let modalContainer = document.getElementById("learn-more-modal");
        for (let element of learnMoreElements) {
            element.addEventListener("click", () => {
                addLearnMoreModalContent(data, element.dataset.productId)
                modalContainer.style.display = "flex";
                resetLearnMoreModal()
            })
        }
    }

    //reset active tab and content block
    const resetLearnMoreModal = () => {
        const contentBlocks = document.getElementsByClassName("modal-content-block");
        const tabsBlock = document.getElementsByClassName("modal-tab");
        Array.from(contentBlocks).forEach((content, i) => {
            content.style.display = i === 0 ? "block" : "none";
        });

        Array.from(tabsBlock).forEach((t, i) => {
            t.classList.toggle("tab-active", i === 0);
        });
    }

    //add content and display hide learn more modal
    const addLearnMoreModalContent = (data, productId) => {
        let matchingProduct = filterList(data.products, productId)
        let productDescriptionBlock = document.getElementById("modal-description-block")
        let productHowToBlock = document.getElementById("modal-howTo-block")
        let productIngredientsBlock = document.getElementById("modal-ingredients-block")
        productDescriptionBlock.innerHTML = matchingProduct.descriptionHtml;
        productHowToBlock.innerText = matchingProduct?.howToUse?.value || "";
        productIngredientsBlock.innerText = matchingProduct?.ingredients?.value || "";
    }

    //handle close modal
    const addModalCloseEvent = () => {
        let closeButton = document.getElementById("close-modal");
        closeButton.addEventListener("click", () => {
            let modalContainer = document.getElementById("learn-more-modal");
            modalContainer.style.display = "none"
        })
    }

    //add listener to tabs 
    const addTabSwitchEventListener = () => {
        const tabsBlock = document.getElementsByClassName("modal-tab");
        const contentBlocks = document.getElementsByClassName("modal-content-block");

        Array.from(tabsBlock).forEach(tab => {
            tab.addEventListener("click", () => {

                const targetTabId = tab.dataset.tabId;

                Array.from(contentBlocks).forEach(content => {
                    const isTargetContent = content.dataset.tabId === targetTabId;
                    content.style.display = isTargetContent ? "block" : "none";
                });

                Array.from(tabsBlock).forEach(t => {
                    t.classList.toggle("tab-active", t === tab);
                });
            });
        });
    };

    //adding scroll to get a sticky button in mobile
    const addScrollEventListener = () => {
        // Function to check if the bottom of an element is in the viewport
        function isElementBottomInViewport(element) {
            const rect = element.getBoundingClientRect();
            return rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
        }

        // Get elements for checking, outside of the scroll handler
        const startingElement = document.querySelector(".product-block:nth-child(2)");
        const endingElement = document.querySelector('.bundle-free-message');
        const stickyButton = document.getElementById("bundle-add-to-cart-cta");

        // Function to handle the scroll logic
        function handleScroll() {
            if (isElementBottomInViewport(startingElement) && !isElementBottomInViewport(endingElement)) {
                stickyButton.style.position = "fixed";
                stickyButton.style.bottom = "0";
            } else {
                stickyButton.style.position = "relative";
            }
        }

        // Optimized scroll event listener with debounce
        window.addEventListener('scroll', handleScroll);
    }

    //check for mobile devices
    const isMobile = () => {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }


    //get bag variant id
    const getBagVariantID = (data) => {
        const selectedVariants = data?.selected_variants;
        for (let product_id in selectedVariants) {
            if (product_id == makeupBagProductId) {
                return selectedVariants[product_id][0]
            }
        }
    }

    const getProduct = (variantId) => {
        const selectedVaraints = recommendationData.selected_variants
        for (let productId in selectedVaraints) {
            if (selectedVaraints[productId][0] == variantId) {
                return filterList(recommendationData.products, productId)
            }
        }
    }

    const getAddToCartEventData = (product, variant)=>{
        return {
        "product_id": product.id,
        "variant_id": extractIdFromGid(variant.id),
        "product_name": product.title,
        "variant_name": variant.title,
        "price": variant.price
        }
    }

    const postCartEvent = (productsAddedtoCart, type = null) => {
        let addedProductVariants = [];
        if (type == "bundle") {
            const bundleVariant = getProductVariant(productsAddedtoCart)
            const addedBundledetail = getAddToCartEventData(productsAddedtoCart, bundleVariant)
            addedProductVariants.push(addedBundledetail);
        } else (
            addedProductVariants = productsAddedtoCart.map((variantId) => {
                const product = getProduct(variantId);
                const variant = filterList(product.variants.edges, variantId);
                return getAddToCartEventData(product, variant.node)
            }))

        fetch('https://s.tangent.ai/recommendation-track', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "resp_id": response_id,
                "event_name": "added_to_cart",
                "event_type": "click",
                "recommendation_url": `https://www.trestique.com/pages/makeup-routine-quiz-recommendation?resp_id=${response_id}`,
                "attributes": { "products": addedProductVariants }
            })
        })
    }

    return {
        init,
        fetchRecommendation,
        displayRecommendation,
        addVariantsToCart,
        isVariantAvalaible,
        getTagsDataForDyanmicVariables,
        getSelectedVariantsObject,
        getRecommendedProductDetails
    }
}();



var valuesCarousal = new Swiper(".valuesCards", {
    slidesPerView: 6, // Default slides per view (desktop)
    spaceBetween: 30, // Space between slides
    pagination: {
        el: ".swiper-pagination",
        clickable: true, // Pagination is clickable
        dynamicBullets: true, // Pagination dots adjust dynamically
    },
    breakpoints: {
        // Mobile: 0px to 768px
        0: {
            slidesPerView: 1.5, // 1 full slide and half of the next slide
            slidesPerGroup: 1, // Move 1 slide at a time
            spaceBetween: 10, // Reduced spacing for mobile
        },
        // Tablet: 768px to 1024px
        768: {
            slidesPerView: 2, // Adjust slides per view for tablets
            slidesPerGroup: 1, // Move 1 slide at a time
        },
        // Desktop: 1024px and above
        1024: {
            slidesPerView: 6, // 6 slides per view for desktop
            slidesPerGroup: 2, // Move 2 slides at a time
        },
    },
});

var carousel = new Swiper(".topReviews", {
    slidesPerView: 5,
    spaceBetween: 0,
    scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        clickable: true,
        draggable: true
    }
});
